import { useFormik } from 'formik';
import type { TFunction } from 'i18next';

import { useFirebaseAuth } from '../../../hooks/useFirebaseAuth';
import { handleAuthError } from '../../../utils/auth/auth-errors';
import { getForgotPasswordFormValidation } from './FormikData';

export function useForgotPasswordPage(t: TFunction, afterSubmit: () => void) {
  const { resetPassword } = useFirebaseAuth();

  const formik = useFormik({
    enableReinitialize: true,
    validateOnChange: true,
    validateOnBlur: true,
    validationSchema: getForgotPasswordFormValidation(t),
    initialValues: { email: '' },
    onSubmit,
  });

  async function onSubmit(values: { email: string }) {
    try {
      await resetPassword(values.email);
      afterSubmit();
    } catch (error: unknown) {
      console.error('Forgot password error: ', error);
      handleAuthError(error, t);
    }
  }

  return { formik };
}
